import Api from "../../../../util/Api";

export default function getInitState() {
    return {
        dataTableOptions: {
            initOnRender: true
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn btn-primary",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Exportálás',
                event_name: "customClick",
                class: "btn btn-success",
                event_payload: 'export'
            },
        ],
        searchFields: [
            {
                name: "doctorId",
                label: "Orvos ID",
                visibility: true,
                formVisible: true,
                formType: 'number',
                formSize: 3,
            },
            {
                name: "doctorIdSelect",
                label: "Orvos neve",
                visibility: true,
                formType: 'select',
                formVisible: true,
                formSize: 3,
                selectOptions: {
                    apiCallback: Api.getAllDoctor,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "professionName",
                label: "Szakma neve (kód nélkül)",
                visibility: true,
                formType: "text",
                formVisible: true,
                formSize: 3,
            },
            {
                name: "treatmentTypeId",
                label: "Vizsgálat ID",
                visibility: true,
                formVisible: true,
                formType: 'number',
                formSize: 3,
            },
            {
                name: "treatmentTypeIdSelect",
                label: "Kezelés neve",
                visibility: true,
                formType: 'select',
                formVisible: true,
                formSize: 3,
                selectOptions: {
                    apiCallback: Api.getAllTreatmentType,
                    formatOption: function (val) {
                        return val.title;
                    },
                    formatText: function (val) {
                        return val.title;
                        },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'title',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    } 
                }

            },
            {
                name: "treatmentTypeDuration",
                label: "Kezelés időtartama",
                visibility: true,
                formVisible: true,
                formType: 'number',
                formSize: 3,
            },
            {
                name: "uniqueTreatmentTypeDuration",
                label: "Kezelés egyedi időtartama",
                visibility: true,
                formVisible: true,
                formType: 'number',
                formSize: 3,
            },
            {
                name: "treatmentTypePrice",
                label: "Kezelés ára",
                visibility: true,
                formVisible: true,
                formType: 'number',
                formSize: 3,
            },
            {
                name: "siteId",
                label: "Ellátóhely ID",
                visibility: true,
                formVisible: true,
                formType: 'number',
                formSize: 3,
            },
            {
                name: "siteIdSelect",
                label: "Ellátóhely",
                visibility: true,
                formType: 'select',
                formVisible: true,
                formSize: 3,
                selectOptions: {
                    apiCallback: Api.getCompanySitesByCompanyId,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            }
        ],
        headerFields: [
            {
                name: "doctorId",
                label: "Orvos ID",
                visibility: true
            },
            {
                name: "doctorName",
                label: "Orvos neve",
                visibility: true,
            },
            {
                name: "professionName",
                label: "Szakma neve (kód nélkül)",
                visibility: true,
            },
            {
                name: "treatmentTypeId",
                label: "Vizsgálat ID",
                visibility: true,
            },
            {
                name: "treatmentTypeName",
                label: "Kezelés neve",
                visibility: true
            },
            {
                name: "treatmentTypeDuration",
                label: "Kezelés időtartama",
                visibility: true,
            },
            {
                name: "uniqueTreatmentTypeDuration",
                label: "Kezelés egyedi időtartama",
                visibility: true,
            },
            {
                name: "treatmentTypePrice",
                label: "Kezelés ára",
                visibility: true,
            },
            {
                name: "siteId",
                label: "Ellátóhely ID",
                visibility: true,
            },
            {
                name: "siteName",
                label: "Ellátóhely Név",
                visibility: true,
            },
        ]
    }
}
